export default __webpack_public_path__ + "static/media/logoWhite.2fb6cc16.svg";